// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a8c40ad8","668":"5c208ef5"}[chunkId] + ".chunk.js";
};